import { render, staticRenderFns } from "./tech-add-or-update.vue?vue&type=template&id=2d0e7719&scoped=true"
import script from "./tech-add-or-update.vue?vue&type=script&lang=js"
export * from "./tech-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./tech-add-or-update.vue?vue&type=style&index=0&id=2d0e7719&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0e7719",
  null
  
)

export default component.exports